/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: 9A1EaT7k4Zaw

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicMobileDrawerItemSubItem.module.css"; // plasmic-import: 9A1EaT7k4Zaw/css

createPlasmicElementProxy;

export type PlasmicMobileDrawerItemSubItem__VariantMembers = {
  active: "active";
};
export type PlasmicMobileDrawerItemSubItem__VariantsArgs = {
  active?: SingleBooleanChoiceArg<"active">;
};
type VariantPropType = keyof PlasmicMobileDrawerItemSubItem__VariantsArgs;
export const PlasmicMobileDrawerItemSubItem__VariantProps =
  new Array<VariantPropType>("active");

export type PlasmicMobileDrawerItemSubItem__ArgsType = { subitem?: any };
type ArgPropType = keyof PlasmicMobileDrawerItemSubItem__ArgsType;
export const PlasmicMobileDrawerItemSubItem__ArgProps = new Array<ArgPropType>(
  "subitem"
);

export type PlasmicMobileDrawerItemSubItem__OverridesType = {
  submenuItem?: Flex__<"div">;
  link?: Flex__<"a"> & Partial<LinkProps>;
  text?: Flex__<"div">;
};

export interface DefaultMobileDrawerItemSubItemProps {
  subitem?: any;
  active?: SingleBooleanChoiceArg<"active">;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicMobileDrawerItemSubItem__RenderFunc(props: {
  variants: PlasmicMobileDrawerItemSubItem__VariantsArgs;
  args: PlasmicMobileDrawerItemSubItem__ArgsType;
  overrides: PlasmicMobileDrawerItemSubItem__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "active",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.active
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"submenuItem"}
      data-plasmic-override={overrides.submenuItem}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.submenuItem,
        { [sty.submenuItemactive]: hasVariant($state, "active", "active") }
      )}
    >
      <PlasmicLink__
        data-plasmic-name={"link"}
        data-plasmic-override={overrides.link}
        className={classNames(
          projectcss.all,
          projectcss.a,
          projectcss.__wab_text,
          sty.link
        )}
        component={Link}
        href={(() => {
          try {
            return $props.subitem.link;
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return "";
            }
            throw e;
          }
        })()}
        platform={"nextjs"}
      >
        <React.Fragment>{$props.subitem.name}</React.Fragment>
      </PlasmicLink__>
      {(() => {
        try {
          return $props.subitem.caption;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return false;
          }
          throw e;
        }
      })() ? (
        <div
          data-plasmic-name={"text"}
          data-plasmic-override={overrides.text}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text
          )}
        >
          <React.Fragment>{$props.subitem.caption}</React.Fragment>
        </div>
      ) : null}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  submenuItem: ["submenuItem", "link", "text"],
  link: ["link"],
  text: ["text"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  submenuItem: "div";
  link: "a";
  text: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicMobileDrawerItemSubItem__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicMobileDrawerItemSubItem__VariantsArgs;
    args?: PlasmicMobileDrawerItemSubItem__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicMobileDrawerItemSubItem__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicMobileDrawerItemSubItem__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicMobileDrawerItemSubItem__ArgProps,
          internalVariantPropNames: PlasmicMobileDrawerItemSubItem__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicMobileDrawerItemSubItem__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "submenuItem") {
    func.displayName = "PlasmicMobileDrawerItemSubItem";
  } else {
    func.displayName = `PlasmicMobileDrawerItemSubItem.${nodeName}`;
  }
  return func;
}

export const PlasmicMobileDrawerItemSubItem = Object.assign(
  // Top-level PlasmicMobileDrawerItemSubItem renders the root element
  makeNodeComponent("submenuItem"),
  {
    // Helper components rendering sub-elements
    link: makeNodeComponent("link"),
    text: makeNodeComponent("text"),

    // Metadata about props expected for PlasmicMobileDrawerItemSubItem
    internalVariantProps: PlasmicMobileDrawerItemSubItem__VariantProps,
    internalArgProps: PlasmicMobileDrawerItemSubItem__ArgProps
  }
);

export default PlasmicMobileDrawerItemSubItem;
/* prettier-ignore-end */
